import * as React from 'react';
import './specialtyBanner.sass';

interface ComponentProps {
    bannerType: string
    title: string
    color: string
    width?: string
    height?: string
}

class SpecialtyBanner extends React.Component<ComponentProps, {}> {

    public render() {
        return <div className="banner-container">
            <div className="banner-base"
                style={{
                    backgroundColor: `${this.props.color}`,
                    height: this.props.height ? `${this.props.height}px` : "",
                    width: this.props.width ? `${this.props.width}px` : "",
                    paddingLeft: this.props.height ? "0px" : "10px"
                }}>
                {this.getIcon(this.props.bannerType, this.props.height!)}
                {this.props.bannerType !== "public" ? 
                <div className="title">{this.props.title}</div>
                :
                <div style={{color:"#7F7F7F"}}>{this.props.title}</div>
                }
            </div>
            <svg width="57" height={this.props.height ? `${this.props.height}` : "63"} viewBox={this.props.height ? `${parseInt(this.props.height) / 2} 0 57 63` : "0 0 57 63"} fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0H57L17.275 33L57 63H0V0Z" fill={`${this.props.color}`} />
            </svg>
        </div>
    }

    private getIcon = (type: string, height: string): JSX.Element => {
        if (type === "mandatory") {
            return <svg width="48" height={height ? `${parseInt(height)}` : "51"} viewBox={this.props.height ? `0 0 48 ${parseInt(this.props.height) + 22}` : "0 0 48 51"} fill="none" xmlns="http://www.w3.org/2000/svg">
                <g data-name="Layer 4">
                <path
                    d="M29.86 34.25h-2.94l-.23-18.37h3.41zm-3.29 5.59a1.92 1.92 0 01.43-1.32 2.2 2.2 0 012.89 0 2 2 0 010 2.64 1.92 1.92 0 01-3.36-1.32z"
                    fill="white"
                />
                <circle
                    cx={28.76}
                    cy={29.48}
                    r={19}
                    fill="none"
                    stroke="white"
                    strokeWidth="2px"
                />
                </g>
            </svg>

        }
        else if (type === "compliance") {

            return <svg width="48" height={height ? `${parseInt(height) - 10}` : "51"} viewBox={this.props.height ? `0 0 48 ${parseInt(this.props.height) + 20}` : "0 0 48 51"} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M51.29 13.38L32.4 5.5a4.78 4.78 0 00-3.64 0L9.87 13.38A4.71 4.71 0 007 17.73c0 19.54 11.27 33 21.8 37.43a4.76 4.76 0 003.63 0c8.43-3.51 21.8-15.65 21.8-37.43a4.71 4.71 0 00-2.94-4.35zm-20.1 38.88a1.68 1.68 0 01-1.21 0c-9.64-3.82-19.87-17.21-19.87-34.53a1.56 1.56 0 011-1.45L30 8.41a1.59 1.59 0 011.21 0l18.89 7.87a1.53 1.53 0 011 1.45C51 35.05 40.81 48.44 31.19 52.26z"
              fill="white"
              data-name="Layer 3"
            />
          </svg>
        }
        else if (type === "complianceChecked") {
            return <svg width="48" height={height ? `${parseInt(height) - 10}` : "51"} viewBox={this.props.height ? `0 0 48 ${parseInt(this.props.height) + 20}` : "0 0 48 51"} fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                <style>
                    {
                    ".cls-2{fill:none;stroke:white;stroke-miterlimit:10;stroke-width:4px}"
                    }
                </style>
                </defs>
                <g id="Layer_3" data-name="Layer 3">
                <path
                    d="M49.13 12.52L30.24 4.65a4.73 4.73 0 00-1.82-.36 4.68 4.68 0 00-1.81.36l-18.9 7.87a4.72 4.72 0 00-2.91 4.36c0 19.53 11.27 33 21.8 37.42a4.67 4.67 0 003.63 0C38.66 50.79 52 38.66 52 16.88a4.72 4.72 0 00-2.87-4.36zM29 51.4a1.59 1.59 0 01-1.21 0C18.19 47.58 8 34.2 8 16.88a1.58 1.58 0 011-1.46l18.81-7.87a1.59 1.59 0 011.21 0l18.89 7.87a1.55 1.55 0 011 1.46C48.89 34.2 38.65 47.58 29 51.4z"
                    fill="white"
                />
                <path className="cls-2" d="M16.62 28.21L24.91 36.78" />
                <path className="cls-2" d="M41.36 19.72L23.24 37.97" />
                </g>
            </svg>
        }
        else if (type === "breaking") {
            return <svg width="48" height={height ? `${parseInt(height)}` : "34"} viewBox={this.props.height ? `0 0 48 ${parseInt(this.props.height) + 20}` : "0 0 38 34"} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
            d="M46.37 24.75V14.6a2.14 2.14 0 00-2.11-2.12 2.05 2.05 0 00-1.31.46l-5.61 4.52a16 16 0 01-10 3.52H14.7a4.23 4.23 0 00-4.22 4.25v6.37a4.23 4.23 0 004.22 4.25v2.13a17 17 0 001.68 7.36 2.09 2.09 0 001.88 1.14h7A2.12 2.12 0 0027 43.12 8.51 8.51 0 0125.22 38a8.3 8.3 0 01.29-2.13h1.86a16 16 0 0110 3.52l5.61 4.52a2.07 2.07 0 001.31.46 2.13 2.13 0 002.12-2.12V32.07a4.23 4.23 0 000-7.32zm-21.13 19.6h-7A14.37 14.37 0 0116.78 38v-2.13h6.55a10.32 10.32 0 00-.22 2.13 10.46 10.46 0 002.13 6.35zM14.7 33.73a2.13 2.13 0 01-2.11-2.13v-6.37a2.13 2.13 0 012.11-2.13h12.67v10.63zm29.56 8.43a.39.39 0 010 .06l-5.59-4.51a18.13 18.13 0 00-9.17-3.84V23a18.13 18.13 0 009.17-3.84l5.59-4.51z"
            fill="white"
            data-name="Layer 5"
            />
            </svg>
        }
        else if (type === "featured") {
            return <svg width="48" height={height ? `${parseInt(height) - 10}` : "34"} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 400 512">
                <path d="M509.861,408.064l-92.864-161.216c9.6-21.728,15.008-45.664,15.008-70.848c0-97.056-78.944-176-176-176
                   s-176,78.944-176,176c0,25.184,5.408,49.12,15.008,70.816L2.149,408c-3.232,5.632-2.784,12.64,1.184,17.76
                   s10.592,7.424,16.832,5.696l93.952-25.28l24.992,93.92c1.664,6.272,6.944,10.912,13.344,11.744c0.736,0.128,1.44,0.16,2.112,0.16
                   c5.664,0,10.976-3.008,13.856-8l87.584-151.616L343.589,504c2.88,4.992,8.192,8,13.856,8c0.672,0,1.408-0.032,2.112-0.128
                   c6.4-0.832,11.68-5.472,13.344-11.744l24.992-93.92l93.952,25.28c6.24,1.728,12.896-0.576,16.832-5.696
                   C512.613,420.672,513.093,413.664,509.861,408.064z M160.069,454.496l-19.168-72.032c-1.088-4.096-3.776-7.616-7.456-9.76
                   c-3.68-2.112-8.096-2.656-12.16-1.6l-72.128,19.392l64.32-111.648c25.504,35.264,63.616,60.8,107.808,69.696L160.069,454.496z
                    M112.005,176c0-79.392,64.608-144,144-144s144,64.608,144,144s-64.608,144-144,144S112.005,255.392,112.005,176z
                    M390.725,371.136c-4.096-1.088-8.48-0.512-12.16,1.6s-6.368,5.632-7.456,9.76l-19.168,72.032l-61.216-105.952
                   c44.16-8.864,82.304-34.432,107.808-69.696l64.32,111.648L390.725,371.136z" fill="white" />
                <path d="M351.173,136.064c-1.696-5.152-5.888-9.056-11.136-10.432l-45.376-11.872l-24.896-41.92c-5.76-9.728-21.76-9.728-27.488,0
                   l-24.896,41.92l-45.408,11.872c-5.28,1.376-9.44,5.28-11.168,10.432c-1.728,5.152-0.704,10.784,2.688,15.04l30.432,38.08
                   l-3.328,49.76c-0.352,5.536,2.176,10.88,6.72,14.112s10.432,3.84,15.52,1.664l43.168-18.336l43.168,18.336
                   c2.016,0.864,4.16,1.28,6.272,1.28c3.264,0,6.528-0.992,9.28-2.944c4.544-3.232,7.072-8.576,6.688-14.112l-3.328-49.76l30.4-38.08
                   C351.877,146.88,352.869,141.216,351.173,136.064z M289.221,174.08c-2.496,3.136-3.744,7.072-3.456,11.04l2.016,29.984
                   l-25.504-10.848c-2.016-0.864-4.16-1.28-6.272-1.28s-4.256,0.416-6.272,1.28l-25.472,10.848l1.984-29.984
                   c0.288-3.968-0.96-7.904-3.456-11.04l-18.912-23.712l27.936-7.328c4.064-1.056,7.552-3.712,9.696-7.296l14.496-24.416
                   l14.496,24.416c2.144,3.584,5.632,6.24,9.696,7.296l27.936,7.328L289.221,174.08z" fill="white" />
            </svg>
        } else if (type === "restricted") {
            return <svg width="48" height={height ? `${parseInt(height)}` : "34"} viewBox={this.props.height ? `0 0 48 ${parseInt(this.props.height) + 20}` : "0 0 38 34"} fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <style>
                {
                  ".cls-1{fill:none;stroke:white;stroke-miterlimit:10;stroke-width:2px}"
                }
              </style>
            </defs>
            <g id="Layer_2" data-name="Layer 2">
              <path className="cls-1" d="M36.28 48.5H12.89V7.78h26v8.41h8.16v14" />
              <path className="cls-1" d="M39.07 7.6L47.27 16.02" />
              <rect
                className="cls-1"
                x={38.68}
                y={39.32}
                width={13.37}
                height={11.37}
                rx={0.69}
              />
              <path
                d="M41.37 39.66v-3.55a4 4 0 014-4h0a4 4 0 014 4v3.51"
                strokeWidth="2px"
                fill="none"
                stroke="white"
                strokeMiterlimit={10}
              />
            </g>
          </svg>
        } else if (type === "public") {
            return <svg width="48" height={height ? `${parseInt(height)}` : "34"} viewBox={this.props.height ? `0 0 48 ${parseInt(this.props.height) + 20}` : "0 0 38 34"} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M29 4A26 26 0 113 30.19 25.88 25.88 0 0129 4zm22.92 18c-.16-3.48-2.81-3.74-5.09-4.6s-3.94-1.34-5.43 1.26c-.93 1.64-4.52 1.68-6.11.43s-1.44-2.81 0-5.11a7.51 7.51 0 00.93-3 38.31 38.31 0 000-4.17c-3.51-1.42-3.51-1.42-6 1.45-.47.55-.92 1.12-1.4 1.65-1.37 1.5-2.75 1.43-4.11 0a10.84 10.84 0 01-1.24-1.47c-1.32-2.1-2.8-1.85-4.64-.37 1 1.18 2 2.25 2.89 3.34 2 2.41 1.86 2.72-1 3.95A5.4 5.4 0 0018 17.87c-1.52 3.85-1.4 3.9-5.57 3.23-.59 1.59-1.28 3.2-1.76 4.86-.19.65-.19 1.78.18 2.05a2.84 2.84 0 002.26.19c2-.72 7.23.74 7.74 2.74.68 2.73 2.49 3.54 4.74 4.33a2.56 2.56 0 011.32 2.1A16.19 16.19 0 0125 43.21c-1 1.48-1.08 2.55-.21 3.85a3.5 3.5 0 01-.22 4.42 23.18 23.18 0 00-1.21 2.06c6.81 2.6 18.5-.59 22.93-6.28.34-.43.14-1.35.06-2-.15-1.44-.82-3-.49-4.28.65-2.56.37-4.67-1.45-6.6a10.86 10.86 0 01-1.39-2 2 2 0 00-2.77-1C38 32.11 36.38 31 35.59 29a5.24 5.24 0 011.25-6.11c1.78-1.84 3.48-2.47 5.68-1.15 3.15 1.89 6.27.86 9.4.26zm-4.43 22.76h1a23.14 23.14 0 004.85-18.08c-.46-3.25-.58-3-3.82-2.73a15 15 0 01-6.72-.63c-2.47-1-4.2-.71-5.35 1.46a5.5 5.5 0 00-.21 3.72c.33 1.18 1.41 1.73 2.89 1.24a3.22 3.22 0 014.19 1.77 13.11 13.11 0 001.64 2.36 6.58 6.58 0 011.4 6.65c-.36 1.32.05 2.84.13 4.24zm-21.65-7.54a10.59 10.59 0 00-1.4-.79c-2.3-.73-4.16-1.52-5-4.41-.35-1.24-3.34-1.83-5.21-2.47-.37-.12-1.55.87-1.63 1.44-.32 2.41-1.64 5 1.14 7a3.4 3.4 0 011.12 2.3c.33 5.2 4.13 8 7.29 11.34C24 50.24 24 48.82 23 47a4.93 4.93 0 01-.14-3.51 66.24 66.24 0 012.98-6.27zm-5.36 15.16c-.9-1-1.74-2-2.7-3a13.1 13.1 0 01-4.23-7.84A5.86 5.86 0 0012 38.49a4.65 4.65 0 01-1.37-4.11c.16-1.39.48-3.11-.14-4.18A54.57 54.57 0 005.61 24C1.88 34.44 8.25 48.5 20.48 52.38zm1-38.72l-4.3-5a24.55 24.55 0 00-9.16 8.81c-2.22 3.62-2.14 4.4.93 7.87 1.67-2.44.91-7.8 6.6-5.18.86-3.25 1.45-6.38 5.97-6.5zm28 2.92a24.26 24.26 0 00-9.17-8.26 2.48 2.48 0 00-2.07-.16 2.25 2.25 0 00-.54 2.07c.75 1.87 0 3.21-1 4.65-.45.65-1 1.87-.75 2.23a3 3 0 002.36 1A4.19 4.19 0 0041 16.68a3.25 3.25 0 014.5-1.35c1.03.46 2.19.67 3.98 1.25zM26.79 9.75L30 6l-.27-.57-6.24.57z"
              fill="#7F7F7F"
            />
          </svg>
        }
        else {
            return <svg width="38" height={height ? `${parseInt(height) - 10}` : "34"} viewBox={this.props.height ? `0 -8 38 ${parseInt(this.props.height) + 10}` : "0 0 38 34"} fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
        }
    }
}

export default SpecialtyBanner;